import { useEffect, useState } from 'react';
export function useMediaMatches(query) {
    const [matches, setMatches] = useState(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
            return false;
        return window.matchMedia(query).matches;
    });
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
            return;
        const mq = window.matchMedia(query);
        const handler = (e) => setMatches(e.matches);
        mq.addEventListener('change', handler);
        setMatches(mq.matches);
        return () => mq.removeEventListener('change', handler);
    }, [query]);
    return matches;
}
//# sourceMappingURL=use-media-matches.js.map